import { render, staticRenderFns } from "./ShelveForm.vue?vue&type=template&id=27d4fa82&"
import script from "./ShelveForm.vue?vue&type=script&lang=js&"
export * from "./ShelveForm.vue?vue&type=script&lang=js&"
import style0 from "./ShelveForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports